import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form, Container, Card } from 'react-bootstrap';
import { CheckCircle, XCircle, InfoCircle } from 'react-bootstrap-icons';

const LoginPageApp = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [generatedOtp, setGeneratedOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [otpStatus, setOtpStatus] = useState(null);
  const [otpMessage, setOtpMessage] = useState(null); // New
  const [otpMessageType, setOtpMessageType] = useState(null); // 'success' | 'error' | 'info'

  const navigate = useNavigate();

  const validUsers = [
    { email: 'iamprousers@gmail.com', password: 'admin123' },
    { email: 'farhanrajput1622@gmail.com', password: 'farhan@M123' },
    { email: 'bn8458408@gmail.com', password: 'bn8458408' },
  ];

  const handleSendOtp = async () => {
    const isValidEmail = validUsers.some((user) => user.email === email);
        if (!isValidEmail) {
        setOtpMessage('Enter a valid email address.');
        setOtpMessageType('error');
        setTimeout(() => {
            setOtpMessage(null);
            setOtpMessageType(null);
        }, 2000);
        return;
        }

    const randomOtp = Math.floor(100000 + Math.random() * 900000).toString();
    setGeneratedOtp(randomOtp);
    setOtpSent(true);

    try {
      const response = await fetch('https://ricgop.online/api/send-appointment-otp.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, otp: randomOtp }),
      });

      const result = await response.json();
      if (result.success) {
        setOtpMessage('OTP sent to your email.');
        setOtpMessageType('success');
      } else {
        setOtpMessage('Failed to send OTP: ' + result.message);
        setOtpMessageType('error');
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
      setOtpMessage('Error sending OTP. Please try again.');
      setOtpMessageType('error');
    }

    setTimeout(() => {
      setOtpMessage(null);
      setOtpMessageType(null);
    }, 3000);
  };

  const handleVerifyOtp = () => {
    if (otp === generatedOtp) {
      setOtpVerified(true);
      setOtpStatus('verified');
    } else {
      setOtpStatus('invalid');
    }

    setTimeout(() => setOtpStatus(null), 2000);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = validUsers.some((user) => user.email === email && user.password === password);

    if (otpVerified && isValid) {
      setShowSuccess(true);
      setShowError(false);
      onLogin();
      setTimeout(() => navigate('/getAppointment/dashboard'), 2000);
    } else {
      setShowError(true);
      setShowSuccess(false);
      setTimeout(() => setShowError(false), 1000);
    }
  };

  return (
    <div className="login-page">
      <Container className="d-flex justify-content-center align-items-center vh-100 position-relative">
        {(showSuccess || showError || otpStatus || otpMessage) && (
          <div className="overlay">
            <div className="popup-message">
              {showSuccess && (
                <>
                  <CheckCircle size={50} className="icon text-success" />
                  <h4>Login Successful</h4>
                  <p>Redirecting to dashboard...</p>
                </>
              )}
              {showError && (
                <>
                  <XCircle size={50} className="icon text-danger" />
                  <h4>Login Failed</h4>
                  <p>Invalid credentials or OTP.</p>
                </>
              )}
              {otpStatus === 'verified' && (
                <>
                  <CheckCircle size={50} className="icon text-success" />
                  <h4>OTP Verified</h4>
                  <p>You can now log in.</p>
                </>
              )}
              {otpStatus === 'invalid' && (
                <>
                  <XCircle size={50} className="icon text-danger" />
                  <h4>Invalid OTP</h4>
                  <p>Please try again.</p>
                </>
              )}
              {otpMessage && (
                <>
                  {otpMessageType === 'success' && <CheckCircle size={50} className="icon text-success" />}
                  {otpMessageType === 'error' && <XCircle size={50} className="icon text-danger" />}
                  {otpMessageType === 'info' && <InfoCircle size={50} className="icon text-primary" />}
                  <h4>{otpMessageType === 'success' ? 'Success' : 'Notice'}</h4>
                  <p>{otpMessage}</p>
                </>
              )}
            </div>
          </div>
        )}

        <Card className="login-card shadow-lg p-4">
          <Card.Body>
           <div className="text-center mb-4">
            <img src="../../assets/img/logo/new-logo.png" alt="Logo" className="login-logo mb-2" />
            <h2 className="fw-bold text-black">Rawalpindi Institute Of Cardiology</h2>
            <h4 className="fw-bold text-white">Get Appointments</h4>
            </div>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>

              {!otpSent ? (
                <Button variant="light" className="w-100 mb-3" onClick={handleSendOtp}>
                  Send OTP
                </Button>
              ) : (
                <>
                  <Form.Group className="mb-3">
                    <Form.Label>Enter OTP</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter OTP sent to email"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </Form.Group>
                  <Button variant="success" className="w-100 mb-3" onClick={handleVerifyOtp}>
                    Verify OTP
                  </Button>
                </>
              )}

              <Form.Group className="mb-4">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Password"
                  value={password}
                  required
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>

              {otpVerified && (
                <Button variant="primary" type="submit" className="w-100">
                  Log In
                </Button>
              )}
            </Form>
          </Card.Body>
        </Card>
      </Container>

      <style>{`
        .login-page {
          background: linear-gradient(to right, #66a8ea, #0090ab);
          min-height: 100vh;
          font-family: 'Segoe UI', sans-serif;
        }

        .login-card {
          width: 100%;
          max-width: 420px;
          border-radius: 1rem;
          backdrop-filter: blur(15px);
          background: rgba(255, 255, 255, 0.2);
          border: 1px solid rgba(255, 255, 255, 0.2);
          color: #fff;
        }

        .form-control {
          background: rgba(255, 255, 255, 0.1);
          color: #fff;
          border: none;
        }

        .form-control:focus {
          background: rgba(255, 255, 255, 0.15);
          box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.25);
          color: #fff;
        }

        .form-label {
          font-weight: 500;
        }

        .btn-primary {
          background-color: #ffffff;
          color: #764ba2;
          font-weight: bold;
          border: none;
          transition: all 0.3s ease;
        }

        .btn-primary:hover {
          background-color: #f1f1f1;
          color: #5a3b8c;
        }

        .overlay {
          position: absolute;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background-color: rgba(0, 0, 0, 0.0);
          z-index: 10;
          display: flex;
          justify-content: center;
          align-items: center;
          animation: fadeIn 0.3s ease-in-out;
        }

        .popup-message {
          background: #fff;
          color: #333;
          text-align: center;
          padding: 30px 40px;
          border-radius: 15px;
          animation: popUp 0.4s ease-in-out;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
        }

        .popup-message h4 {
          margin-bottom: 5px;
        }

        .popup-message .icon {
          margin-bottom: 10px;
        }

        @keyframes fadeIn {
          from { opacity: 0 }
          to { opacity: 1 }
        }

        @keyframes popUp {
          from { transform: scale(0.7); opacity: 0 }
          to { transform: scale(1); opacity: 1 }
        }
            .login-logo {
            max-width: 140px;
            height: auto;
            border-radius: 12px;
            }
      `}</style>
    </div>
  );
};

export default LoginPageApp;
